module.exports = __webpack_public_path__ + "static/media/S (1).051df8f0.jpg";